<template>
  <div>
    <v-row class="mt-12 ml-10">
      <v-btn
        icon
        class="hidden-xs-only"
        color="primary"
        @click="$router.push('/users')"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <p class="text-h5 bold ml-4">
        <b>{{ getTitle() }}</b>
      </p>
    </v-row>

    <v-card
      class="mr-12 ml-12 mb-12 mt-8"
      flat
      fill-height
      style="background-color: #f5f5f5"
    >
      <v-tabs show-arrows grow>
        <v-tab>
          <v-icon left> mdi-account </v-icon>
          Dados Gerais
        </v-tab>
        <v-tab>
          <v-icon left> mdi-phone </v-icon>
          Contato
        </v-tab>
        <v-tab>
          <v-icon left> mdi-lock </v-icon>
          Permissão
        </v-tab>
        <v-tab>
          <v-icon left> mdi-map-marker </v-icon>
          Endereço
        </v-tab>
        <v-tab-item>
          <v-card flat class="pt-6">
            <v-card-text>
              <v-form
                ref="generalDataForm"
                v-model="validGeneralData"
                lazy-validation
              >
                <v-row :gutter="20">
                  <v-col lg="6" sm="12" xs="12">
                    <v-text-field
                      v-model="form.firstName"
                      label="Nome"
                      outlined
                      name="firstName"
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col lg="6" sm="12" xs="12">
                    <v-text-field
                      v-model="form.lastName"
                      label="Sobrenome"
                      outlined
                      name="lastName"
                      :rules="stringRules"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col lg="6" sm="12" xs="12">
                    <v-text-field
                      v-model="form.email"
                      label="E-mail"
                      outlined
                      name="email"
                      :rules="emailRules"
                    />
                  </v-col>
                  <v-col>
                    <v-switch
                      v-model="form.isActive"
                      label="Ativo"
                      name="active"
                      inset
                      color="secondary"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col lg="3" sm="12" xs="12">
                    <v-text-field
                      v-model="form.cpf"
                      v-mask="'###.###.###-##'"
                      :rules="[...cpfRules, ...stringRules]"
                      label="CPF"
                      name="cpf"
                      outlined
                      @blur="parseCpf(form.cpf)"
                    />
                  </v-col>

                  <v-col lg="3" sm="12" xs="12">
                    <v-text-field
                      v-model="form.rg"
                      :rules="stringRules"
                      label="RG"
                      name="rg"
                      outlined
                    />
                  </v-col>

                  <v-col lg="3" sm="12" xs="12">
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="form.dob"
                          label="Data de Entrada no PEJA"
                          outlined
                          v-bind="attrs"
                          :rules="stringRules"
                          @blur="date = parseDate(form.dob)"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="dataDeNascimento"
                        no-title
                        @input="menu = false"
                      />
                    </v-menu>
                  </v-col>

                  <v-col lg="3" sm="12" xs="12">
                    <v-select
                      v-model="form.gender"
                      :items="genders"
                      label="Gênero"
                      :rules="stringRules"
                      outlined
                    />
                  </v-col>
                </v-row>
                <v-row v-if="form.profileId === profiles.MONITOR_BOLSISTA">
                  <v-col lg="6" sm="12" xs="12">
                    <v-text-field
                      v-model="form.bankAgency"
                      label="Agência bancária"
                      name="bankAgency"
                      outlined
                    />
                  </v-col>

                  <v-col lg="6" sm="12" xs="12">
                    <v-text-field
                      v-model="form.bankAccountNumber"
                      label="Conta bancária"
                      name="bankAccountNumber"
                      outlined
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col align="end">
                  <v-btn rounded color="primary" @click="addPhone">
                    <v-icon class="mr-2">mdi-plus</v-icon>
                    NOVO TELEFONE
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-text v-if="form.phones && form.phones.length > 0">
              <v-form
                ref="phoneNumberForm"
                v-model="validPhoneNumber"
                lazy-validation
              >
                <v-row v-for="(item, i) in form.phones" :key="i" :gutter="20">
                  <v-col lg="5" sm="12" xs="12">
                    <v-text-field
                      v-model="item.number"
                      v-mask="'(##) #####-####'"
                      :label="`Número ${i + 1}`"
                      outlined
                      name="number"
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col lg="3" sm="12" xs="12">
                    <v-text-field
                      v-model="item.type"
                      :label="`Tipo ${i + 1}`"
                      outlined
                      name="type"
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col lg="3" sm="12" xs="12">
                    <v-text-field
                      v-model="item.obs"
                      :label="`Observação ${i + 1}`"
                      outlined
                      name="obs"
                    />
                  </v-col>
                  <v-col
                    v-if="$vuetify.breakpoint.mdAndUp"
                    lg="1"
                    sm="12"
                    xs="12"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mt-2"
                          icon
                          large
                          v-bind="attrs"
                          v-on="on"
                          @click="removePhone(i)"
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>Excluir contato</span>
                    </v-tooltip>
                  </v-col>
                  <v-row v-if="$vuetify.breakpoint.smAndDown">
                    <v-col class="mb-4" align="center">
                      <v-btn
                        width="50vw"
                        rounded
                        color="secondary"
                        @click="removePhone(i)"
                      >
                        <v-icon class="mr-2">mdi-delete</v-icon>
                        REMOVER
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-text v-else> Nenhum telefone cadastrado. </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-form ref="profileForm" v-model="validProfile" lazy-validation>
                <v-row :gutter="20" class="pt-6">
                  <v-col lg="3" sm="12" xs="12">
                    <v-select
                      v-model="form.profileId"
                      :items="profilesSelect"
                      label="Perfil"
                      :disabled="verifyIsEdit()"
                      outlined
                      @change="changedProfileId($event)"
                    />
                  </v-col>
                </v-row>

                <v-row :gutter="20">
                  <v-col lg="3" sm="12" xs="12">
                    <v-switch
                      v-model="permissions[+form.profileId - 1][0]"
                      label="Download"
                      name="download"
                      disabled
                      inset
                      color="secondary"
                    />
                  </v-col>
                  <v-col lg="3" sm="12" xs="12">
                    <v-switch
                      v-model="permissions[+form.profileId - 1][1]"
                      label="Upload"
                      name="upload"
                      disabled
                      inset
                      color="secondary"
                    />
                  </v-col>
                  <v-col lg="3" sm="12" xs="12">
                    <v-switch
                      v-model="permissions[+form.profileId - 1][2]"
                      label="Remoção"
                      name="delete"
                      disabled
                      inset
                      color="secondary"
                    />
                  </v-col>
                  <v-col lg="3" sm="12" xs="12">
                    <v-switch
                      v-model="permissions[+form.profileId - 1][3]"
                      label="Edição"
                      name="edit"
                      disabled
                      inset
                      color="secondary"
                    />
                  </v-col>
                </v-row>
                <v-row
                  v-if="
                    form.profileId === profiles.COORDENADOR_DOCENTE ||
                    form.profileId === profiles.ADMINISTRADOR
                  "
                  :gutter="20"
                  class="pt-6"
                >
                  <v-col lg="6" sm="12" xs="12">
                    <v-text-field
                      v-model="specificDetails.registerNumber"
                      label="Número de registro"
                      outlined
                      name="registerNumber"
                      :rules="stringRules"
                    />
                  </v-col>
                </v-row>
                <v-row
                  v-if="form.profileId === profiles.COORDENADOR_DISCENTE"
                  :gutter="20"
                  class="pt-6"
                >
                  <v-col lg="6" sm="12" xs="12">
                    <v-text-field
                      v-model="specificDetails.ra"
                      label="Número do RA"
                      outlined
                      name="ra"
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col lg="6" sm="12" xs="12">
                    <v-text-field
                      v-model="specificDetails.note"
                      label="Observação"
                      outlined
                      name="note"
                    />
                  </v-col>
                </v-row>
                <v-row
                  v-if="
                    form.profileId === profiles.MONITOR_BOLSISTA ||
                    form.profileId === profiles.MONITOR_VOLUNTARIO
                  "
                  :gutter="20"
                  class="pt-6"
                >
                  <v-col lg="6" sm="12" xs="12">
                    <v-text-field
                      v-model="specificDetails.course"
                      label="Curso"
                      outlined
                      name="course"
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col lg="6" sm="12" xs="12">
                    <v-text-field
                      v-model="specificDetails.period"
                      label="Período"
                      outlined
                      name="period"
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col lg="6" sm="12" xs="12">
                    <v-text-field
                      v-model="specificDetails.motherName"
                      label="Nome da mãe"
                      outlined
                      name="motherName"
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col lg="6" sm="12" xs="12">
                    <v-text-field
                      v-model="specificDetails.fathersName"
                      label="Nome do pai"
                      outlined
                      name="fathersName"
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col>
                    <v-switch
                      v-model="specificDetails.isScholarshipHolder"
                      label="É bolsista"
                      name="isScholarshipHolder"
                      disabled
                      inset
                      color="secondary"
                    />
                  </v-col>
                </v-row>
                <v-row
                  v-if="form.profileId === profiles.EDUCANDO"
                  :gutter="20"
                  class="pt-6"
                >
                  <v-col lg="6" sm="12" xs="12">
                    <v-text-field
                      v-model="specificDetails.scholarMeta"
                      label="Meta escolar"
                      outlined
                      name="scholarMeta"
                      :rules="stringRules"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat class="pt-6">
            <v-card-text>
              <v-row>
                <v-col align="end">
                  <v-btn rounded color="primary" @click="addAddress">
                    <v-icon class="mr-2">mdi-plus</v-icon>
                    NOVO ENDERECO
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-text v-if="form.addresses && form.addresses.length > 0">
              <v-form ref="addressForm" v-model="validAddress" lazy-validation>
                <div v-for="(item, i) in form.addresses" :key="i">
                  <p class="mb-6">Endereço {{ i + 1 }}</p>
                  <v-row :gutter="20">
                    <v-col lg="3" sm="12" xs="12">
                      <v-text-field
                        v-model="item.cep"
                        v-mask="'#####-###'"
                        label="CEP"
                        outlined
                        name="cep"
                        :rules="stringRules"
                      />
                    </v-col>
                    <v-col lg="5" sm="12" xs="12">
                      <v-text-field
                        v-model="item.street"
                        label="Rua"
                        outlined
                        name="street"
                        :rules="stringRules"
                      />
                    </v-col>
                    <v-col lg="3" sm="12" xs="12">
                      <v-text-field
                        v-model="item.number"
                        label="Número"
                        outlined
                        name="number"
                        :rules="stringRules"
                      />
                    </v-col>
                    <v-col
                      v-if="$vuetify.breakpoint.mdAndUp"
                      lg="1"
                      sm="12"
                      xs="12"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mt-2"
                            icon
                            large
                            v-bind="attrs"
                            v-on="on"
                            @click="removeAddress(i)"
                          >
                            <v-icon> mdi-delete </v-icon>
                          </v-btn>
                        </template>
                        <span>Excluir endereço</span>
                      </v-tooltip>
                    </v-col>
                    <v-row v-if="$vuetify.breakpoint.smAndDown">
                      <v-col class="mb-4" align="center">
                        <v-btn
                          width="50vw"
                          rounded
                          color="secondary"
                          @click="removeAddress(i)"
                        >
                          <v-icon class="mr-2">mdi-delete</v-icon>
                          REMOVER
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-row>

                  <v-row>
                    <v-col lg="6" sm="12" xs="12">
                      <v-text-field
                        v-model="item.neighborhood"
                        label="Bairro"
                        outlined
                        name="neighborhood"
                        :rules="stringRules"
                      />
                    </v-col>
                    <v-col lg="3" sm="12" xs="12">
                      <v-text-field
                        v-model="item.complement"
                        label="Complemento"
                        outlined
                        name="complement"
                        :rules="stringRules"
                      />
                    </v-col>
                    <v-col lg="3" sm="12" xs="12">
                      <v-text-field
                        v-model="item.type"
                        label="Tipo"
                        outlined
                        name="type"
                        :rules="stringRules"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-form>
            </v-card-text>
            <v-card-text v-else>
              <v-row>
                <v-col align="center">
                  <h3>Nenhum endereço cadastrado.</h3>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>

    <v-row class="mb-2">
      <v-col align="center">
        <v-btn
          class="mr-5"
          large
          rounded
          color="secondary"
          @click="$router.push('/users')"
        >
          CANCELAR
        </v-btn>
        <v-btn large rounded color="primary" @click="sendNewUserData">
          {{ getButtonTitle() }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* eslint-disable import/no-cycle */
import { mapGetters } from 'vuex';

import { profiles, profilesOptions } from '@/utils/Profiles';
import { permissions } from '@/utils/Permissions';
import { stringRules, emailRules, cpfRules } from '@/utils/Rules';
import { newUser, updateUserAdmin } from '@/services/user';

export default {
  name: 'FormUser',
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    userToEdit: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    profilesOptions,
    validGeneralData: false,
    validPhoneNumber: false,
    validProfile: false,
    validAddress: false,
    stringRules,
    emailRules,
    cpfRules,
    permissions,
    profiles,
    dataDeNascimento: '',
    menu: false,
    userToCreate: {
      firstName: '',
      lastName: '',
      cpf: '',
      rg: '',
      isActive: true,
      dob: '',
      gender: '',
      phones: [{ number: '', type: '', obs: '' }],
      addresses: [
        {
          street: '',
          neighboorhood: '',
          cep: '',
          number: '',
          complement: '',
          type: '',
        },
      ],
      profileId: profiles.EDUCANDO,
      profile: {
        description: '',
        permission: {
          toUpload: false,
          toDownload: false,
          toDelete: false,
          toEdit: false,
        },
      },
    },
    specificDetails: {
      type: 'student',
      scholarMeta: '',
      status: false,
    },
    deletePhones: [],
    deleteAddresses: [],
    form: {},
    genders: [
      {
        text: 'Feminino',
        value: 'F',
      },
      {
        text: 'Masculino',
        value: 'M',
      },
      {
        text: 'Prefiro não dizer',
        value: 'N',
      },
      {
        text: 'Outros',
        value: 'O',
      },
    ],
    profilesSelect: [
      {
        text: 'Administrador',
        value: 1,
      },
      {
        text: 'Coordenador Docente',
        value: 2,
      },
      {
        text: 'Coordenador Discente',
        value: 3,
      },
      {
        text: 'Monitor Voluntário',
        value: 4,
      },
      {
        text: 'Monitor Bolsista',
        value: 5,
      },
      {
        text: 'Educando',
        value: 6,
      },
      {
        text: 'Usuário Externo',
        value: 7,
      },
    ],
  }),
  computed: {
    ...mapGetters({ user: 'user/getUser' }),
  },
  watch: {
    dataDeNascimento() {
      this.form.dob = this.formatDate(this.dataDeNascimento);
    },
  },
  mounted() {
    this.form =
      this.edit && this.userToEdit
        ? {
            ...this.userToEdit,
            phones: this.userToEdit.phone,
            addresses: this.userToEdit.address,
          }
        : this.userToCreate;
    delete this.form.phone;
    delete this.form.address;
    if (this.edit && this.userToEdit) {
      this.specificDetails = this.getSpecificDetailsToEdit(this.form);
    }

    this.setProfilesToCreate();
  },
  methods: {
    setProfilesToCreate() {
      switch (this.user.profile.id) {
        case profiles.COORDENADOR_DOCENTE:
        case profiles.COORDENADOR_DISCENTE:
          this.profilesSelect = this.profilesOptions.filter(
            (x) => x.value > this.user.profile.id
          );
          break;
        case profiles.MONITOR_VOLUNTARIO:
          this.profilesSelect = this.profilesOptions.filter(
            (x) =>
              x.value === profiles.EDUCANDO ||
              x.value === profiles.USUARIO_EXTERNO
          );
          break;
        case profiles.MONITOR_BOLSISTA:
          this.profilesSelect = this.profilesOptions.filter(
            (x) =>
              x.value === profiles.EDUCANDO ||
              x.value === profiles.USUARIO_EXTERNO ||
              x.value === profiles.MONITOR_VOLUNTARIO
          );
          break;
        default:
          this.profilesSelect = this.profilesOptions;
          break;
      }
    },
    getSpecificDetailsToEdit({
      monitor,
      student,
      studentCoordinator,
      teachingCoordinator,
    }) {
      if (monitor) {
        return { ...monitor, type: 'monitor' };
      }
      if (student) {
        return { ...student, type: 'student' };
      }
      if (studentCoordinator) {
        return { ...studentCoordinator, type: 'student-coordinator' };
      }
      if (teachingCoordinator) {
        return { ...teachingCoordinator, type: 'admin' };
      }
    },
    verifyIsEdit() {
      return !!(this.edit && this.userToEdit);
    },
    getTitle() {
      return this.edit && this.userToEdit
        ? 'EDIÇÃO DE USUÁRIO'
        : 'CRIAÇÃO DE USUÁRIOS';
    },
    getButtonTitle() {
      return this.edit && this.userToEdit ? 'EDITAR USUÁRIO' : 'SALVAR USUÁRIO';
    },
    changedProfileId(id) {
      this.specificDetails = this.getSpecificDetails(id);
    },
    getSpecificDetailsKey(type) {
      if (type === 'admin') {
        return 'teachingCoordinator';
      }
      if (type === 'student-coordinator') {
        return 'studentCoordinator';
      }
      return type;
    },
    isOutside() {
      return (
        this.userToEdit &&
        !this.userToEdit.monitor &&
        !this.userToEdit.student &&
        !this.userToEdit.teachingCoordinator &&
        !this.userToEdit.studentCoordinator
      );
    },
    getValidateInfoMessage(validates) {
      const message = Object.values(validates)
        .reduce(
          (prev, current) =>
            !current.status ? `${prev} ${current.name}` : prev,
          ''
        )
        .split(' ')
        .filter((el) => el && el !== '')
        .join(', ')
        .replace('_', ' ');
      return `Verificar as seguintes abas antes de continuar: ${message}`;
    },
    async sendNewUserData() {
      const isValidGeneralData = this.$refs.generalDataForm
        ? await this.$refs.generalDataForm.validate()
        : false;
      const isValidPhone = this.$refs.phoneNumberForm
        ? await this.$refs.phoneNumberForm.validate()
        : false;
      const isValidProfile = this.$refs.profileForm
        ? await this.$refs.profileForm.validate()
        : false;
      const isValidAddress = this.$refs.addressForm
        ? await this.$refs.addressForm.validate()
        : false;

      if (
        !isValidGeneralData ||
        !isValidPhone ||
        !isValidAddress ||
        !isValidProfile
      ) {
        const validateInfoMessage = this.getValidateInfoMessage({
          generalData: { status: isValidGeneralData, name: 'Dados_Gerais' },
          phone: { status: isValidPhone, name: 'Contato' },
          profile: { status: isValidProfile, name: 'Permissão' },
          address: { status: isValidAddress, name: 'Endereço' },
        });
        this.$root.vtoast.show({
          message: validateInfoMessage,
          top: true,
          right: true,
          show: true,
          color: 'info',
          icon: 'mdi-exclamation-thick',
          timer: 5000,
        });
        return;
      }
      const { phones, addresses, ...userRest } = this.form;
      delete userRest.profile;
      delete userRest.monitor;
      delete userRest.studentCoordinator;
      delete userRest.teachingCoordinator;
      delete userRest.student;
      delete userRest.hasApprovedLgdp;
      delete userRest.aprrovedLgpdDate;

      const baseUser = {
        user: { ...userRest, cpf: this.parseCpf(userRest.cpf) },
        phones: [...phones, ...this.deletePhones],
        addresses: [...addresses, ...this.deleteAddresses],
      };

      if (!this.edit && !this.userToEdit) {
        baseUser.specificDetails = this.specificDetails;
      } else if (this.edit && this.userToEdit && !this.isOutside()) {
        baseUser[this.getSpecificDetailsKey(this.specificDetails.type)] =
          this.specificDetails;
      }

      const resp =
        this.edit && this.userToEdit
          ? await updateUserAdmin(baseUser)
          : await newUser(baseUser);

      if (resp && resp.success) {
        this.$root.vtoast.show({
          message:
            this.edit && this.userToEdit
              ? 'Usuário atualizado com sucesso.'
              : 'Usuário cadastrado com sucesso.',
          top: true,
          right: true,
          show: true,
          color: 'success',
        });
        this.$router.push({ name: 'Users' });
      } else {
        this.$root.vtoast.show({
          message:
            this.edit && this.userToEdit
              ? `Erro ao atualizar usuário.  ${
                  resp.message ? resp.message : ''
                }`
              : `Erro ao cadastrar novo usuário. ${
                  resp.message ? resp.message : ''
                }`,
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      }
    },
    getSpecificDetails(profileId) {
      if (
        profileId === profiles.ADMINISTRADOR ||
        profileId === profiles.COORDENADOR_DOCENTE
      ) {
        return {
          type: 'admin',
          startDate: Date.now(),
          endDate: null,
          registerNumber: '',
        };
      }
      if (profileId === profiles.COORDENADOR_DISCENTE) {
        return {
          type: 'student-coordinator',
          startDate: Date.now(),
          endDate: null,
          ra: '',
          note: '',
        };
      }
      if (profileId === profiles.MONITOR_VOLUNTARIO) {
        return {
          type: 'monitor',
          startDate: Date.now(),
          endDate: null,
          isScholarshipHolder: false,
          course: '',
          period: '',
          motherName: '',
          fatherName: '',
        };
      }
      if (profileId === profiles.MONITOR_BOLSISTA) {
        return {
          type: 'monitor',
          startDate: Date.now(),
          endDate: null,
          isScholarshipHolder: true,
          course: '',
          period: '',
          motherName: '',
          fatherName: '',
        };
      }
      if (profileId === profiles.EDUCANDO) {
        return {
          type: 'student',
          scholarMeta: '',
          status: false,
        };
      }
      return {};
    },
    addAddress() {
      this.form.addresses.push({
        street: '',
        neighboorhood: '',
        cep: '',
        number: '',
        complement: '',
        type: '',
      });
    },
    addPhone() {
      this.form.phones.push({
        number: '',
        type: '',
        obs: '',
      });
    },
    removePhone(index) {
      if (this.form.phones.length === 1) {
        return;
      }
      if (this.edit && this.userToEdit && this.form.phones[index].id) {
        this.deletePhones.push({ ...this.form.phones[index], toDelete: true });
      }
      this.form.phones = this.form.phones.filter((phone, i) => i !== index);
    },
    removeAddress(index) {
      if (this.form.addresses.length === 1) {
        return;
      }
      if (this.edit && this.userToEdit && this.form.addresses[index].id) {
        this.deleteAddresses.push({
          ...this.form.addresses[index],
          toDelete: true,
        });
      }
      this.form.addresses = this.form.addresses.filter(
        (address, i) => i !== index
      );
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    parseCpf(cpf) {
      return cpf.match(/\d+/g).join('');
    },
  },
};
</script>
